import { useEffect } from 'react';

const useCursorHighlight = () => {
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      
      const selectors = [
        '.experience-item',
        '.project-item', 
        '.info-item',
        '.about-container',
        '.contact-form',
        '.footer-container',
        '.skill-card'
      ];
      
      const card = target.closest(selectors.join(', ')) as HTMLElement;
      
      if (card) {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        card.style.setProperty('--cursor-x', `${x}px`);
        card.style.setProperty('--cursor-y', `${y}px`);
        
        const front = card.querySelector('.front') as HTMLElement;
        const back = card.querySelector('.back') as HTMLElement;
        if (front) {
          front.style.setProperty('--cursor-x', `${x}px`);
          front.style.setProperty('--cursor-y', `${y}px`);
        }
        if (back) {
          back.style.setProperty('--cursor-x', `${x}px`);
          back.style.setProperty('--cursor-y', `${y}px`);
        }
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
};

export default useCursorHighlight;
